import React from "react";
import { NavLink } from "react-router-dom";
import "./TabBar.css";

export default class TabBar extends React.Component {
  render() {
    return (
      <div style={{ display: "flex" }}>
        <NavLink
          to="/packages/ready"
          className="navLink"
          activeClassName="navLinkActive"
        >
          <div className="tabBarItem">
            <span>READY FOR PICKUP</span>
          </div>
        </NavLink>
        <NavLink
          to="/packages/otw"
          className="navLink"
          activeClassName="navLinkActive"
        >
          <div className="tabBarItem">
            <span>ON THE WAY</span>
          </div>
        </NavLink>
        <NavLink
          to="/packages/complete"
          className="navLink"
          activeClassName="navLinkActive"
        >
          <div className="tabBarItem">
            <span>COMPLETED PICKUPS</span>
          </div>
        </NavLink>
      </div>
    );
  }
}
